import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsGETApiAuth, AdsPOSTApi, AdsPUTApi } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import Database from '../../../../Constant/database.json'
import ImageUpload from "../../../ImageUpload";
import ExamQuestionModal from "./ExamQuestionModal";
import { CustomButtonUnSelect } from "../../../CustomButtomUnselect";
import FileUpload from "../../../FileUpload";
import FileUploadChapters from "./PDFGroups";
import AudioUpload2 from "./AudioUpload2";

const QuestionBlock = [
  "question_number",
  "question",
  "question_description",
  "question_description_type",
  "question_media",
  "question_media_type",
  "option_1",
  "option_2",
  "option_3",
  "option_4",
  "answer_description",
  "correct_answer",
  "answer_media_type",
]
const Course_type = [
  "Course",
  "Online Class",
  "Book"
]

export default function FormComponent(props) {
  const { FetchData, db_slug, webSlug } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  const [CourseName, setCourseName] = React.useState(FetchData.meta.course_name)
  const [CourseShortDescription, setCourseShortDescription] = React.useState(FetchData.meta.course_short_desc)
  const [CourseDescription, setCourseDescription] = React.useState(FetchData.meta.description)
  const [CourseTime, setCourseTime] = React.useState(FetchData.meta.course_time)
  const [TotalResources, setTotalResources] = React.useState(FetchData.meta.total_resourses)
  const [CoursePrice, setCoursePrice] = React.useState(FetchData.meta.course_price)
  const [Discount, setDiscount] = React.useState(FetchData.meta.discount_price)
  const [CourseType, setCourseType] = React.useState(FetchData.meta.course_type)
  const [CourseCategory, setCourseCategory] = React.useState(FetchData.meta.course_category)
  const [Available, setAvaliable] = React.useState(FetchData.meta.available_unavailable)
  const [WhatWillYouLearn, setWhatWillYouLearn] = React.useState(JSON.parse(FetchData.meta.what_will_you_learn))
  const [WhatWillYouLearnCache, setWhatWillYouLearnCache] = React.useState("")
  const [Requirements, setRequirements] = React.useState(JSON.parse(FetchData.meta.requirements))
  const [RequirementsCache, setRequirementsCache] = React.useState("")
  const [WhoisThisCourseFor, setWhoisThisCourseFor] = React.useState(JSON.parse(FetchData.meta.who_is_this_course_for))
  const [WhoisThisCourseForCache, setWhoisThisCourseForCache] = React.useState("")
  const [ContentPreview, setContentPreview] = React.useState(JSON.parse(FetchData.meta.content_preview))
  const [CourseContent, setCourseContent] = React.useState(JSON.parse(FetchData.meta.course_content))
  const [CourseContentEdit, setCourseContentEdit] = React.useState(false)
  const [CourseEditData, setCourseEditData] = React.useState({})
  const [CourseEditKey, setCourseEditKey] = React.useState("")
  const [FeaturedImage, setFeaturedImage] = React.useState(FetchData.meta.featured_image)


  const [ClassLink, setClassLink] = React.useState(FetchData.meta.class_link)
  const [sendNotification, setSendNotification] = React.useState(false)

  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")
  const [ExamPrice, setExamPrice] = React.useState(db_slug == slugs.db_slug_paid_exam ? FetchData.meta.exam_price : "")
  const [ExamResetPrice, setExamResetPrice] = React.useState(db_slug == slugs.db_slug_paid_exam ? FetchData.meta.exam_reset_price : "")

  const EditInfo = (POSTID, slug, passSlug) => {
    setReload(true)
    var data = {
      title: `${Title}`,
      status: "publish",
      meta: {
        "course_name": `${Title}`,
        "course_short_desc": `${CourseShortDescription}`,
        "what_will_you_learn": `${JSON.stringify(WhatWillYouLearn)}`,
        "requirements": `${JSON.stringify(Requirements)}`,
        "description": `${CourseDescription}`,
        "who_is_this_course_for": `${JSON.stringify(WhoisThisCourseFor)}`,
        "course_time": `${CourseTime}`,
        "total_resourses": `${TotalResources}`,
        "course_price": `${CoursePrice}`,
        "discount_price": `${Discount}`,
        "course_type": `${CourseType}`,
        "course_category": `${CourseCategory}`,
        "content_preview": `${JSON.stringify(ContentPreview)}`,
        "course_content": `${JSON.stringify(CourseContent)}`,
        "available_unavailable": `${Available}`,
        "class_link":`${ClassLink}`,
        "featured_image":FeaturedImage
      }
    }

    if (POSTID === "")
      AdsPOSTApi(data, slug)
        .then((res) => {
          setReload(false)
          setID(res.data.id)
          setAlertShow(true)
          setAlertcomp("Exam Added Successfully")
          console.log(res.data)
          history.push(`${passSlug}${res.data.slug}`)
        }).catch(err => {
          setReload(false)
          console.log(err)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
    else
      AdsPUTApi(data, slug, POSTID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`${Title} edited Successfully`)
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }
  const [batchID, setBatchID] = React.useState(FetchData.meta.batch_id)
  const [batchName, setBatchName] = React.useState(FetchData.meta.batch_name)
  const [batchModal, setBatchModal] = React.useState(false)
  const [batchList, setBatchList] = React.useState([])

  useEffect(() => {
    if (db_slug == "daily_exam")
      BatchList()
  }, [])
  const BatchList = () => {
    AdsGETApiAuth(
      { per_page: 100, _fields: "id,title,meta.batch_status,meta.batch_start_date,meta.batch_end_date" },
      slugs.db_slug_batch
    )
      .then((res) => {
        setBatchList(res.data)
      })
      .catch(e => {
        console.log(e)
      })
  }

  return (
    <div>
      <div className="row">
        <div className=" col-1"></div>
        <div className=" col-10 form-view mb-3">
          <h4><center>Exam Information</center></h4>

          <table>
            <tbody>
              <tr>
                <td className="col-3">Course Title</td>
                <td className="col-6">
                  <input className="input-common-4"
                    value={Title} placeholder="Name"
                    onChange={(event) => { setTitle(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Short Description</td>
                <td className="col-6">
                  <input className="input-common-4"
                    value={CourseShortDescription} placeholder="Short Description"
                    onChange={(event) => { setCourseShortDescription(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Availability</td>
                <td className="col-6">
                  <CustomButton setData={setAvaliable} Data={Available} DataValue={"Available"} />
                  <CustomButton setData={setAvaliable} Data={Available} DataValue={"Unavailable"} />
                </td>
              </tr>
              <tr>
                <td className="col-3">Featured Image</td>
                <td className="col-6">
                  <ImageUpload
                    ImageUrl={FeaturedImage}
                    setImageUrl={setFeaturedImage}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Course Type</td>
                <td className="col-6">
                  <div style={{ display: "inline" }}>
                    {Course_type.map((item, index) => (
                      <div style={{ display: "inline-block" }} key={index}>
                        <CustomButton setData={setCourseType} Data={CourseType} DataValue={item} />
                      </div>
                    ))}
                  </div>
                </td>
              </tr>
              {CourseType == "Online Class" &&
                <tr>
                  <td className="col-3">Class Link</td>
                  <td className="col-6">
                    <input className="input-common-4"
                      value={ClassLink} placeholder="Class Link"
                      onChange={(event) => { setClassLink(event.target.value) }}
                    />
                  </td>
                </tr>
              }
              <tr>
                <td className="col-3">Course Category</td>
                <td className="col-6">
                  <input className="input-common-4"
                    value={CourseCategory} placeholder="Course Category"
                    onChange={(event) => { setCourseCategory(event.target.value) }}
                  />
                </td>
              </tr>

            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo(ID, db_slug, webSlug)
                }}
              >
                Update Course
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-1"></div>
        <div className="col-10 form-view mb-3">
          <h4><center>Course Content</center></h4>
          <div>
            <div className="row center m-2">
              <div className=" col-3" style={{ padding: "0 10px" }}>
                <div className="sign-in-button-4"
                  onClick={() => {
                    setCourseEditData({
                      "chapter_number": `${Object.keys(CourseContent).length + 1}`,
                      "title": "",
                      "description": "",
                      "is_preview": "",
                      "chapter_type": "Video",
                      "video_link": "",
                      "youtube_id": "",
                      "content": "",
                      "time": "",
                      "pdf_url": "",
                      "pdf_list": "[]",
                      "audio_list": "[]",
                    })
                    setCourseEditKey(`item-${Object.keys(CourseContent).length}`)

                    setCourseContentEdit(true)
                  }}
                >
                  Add Chapter
                </div>
              </div>
            </div>
            <div>
              <div className="row m-4">
                <div>
                  <div className="row">
                    {Object.values(CourseContent).map((item, index) => {
                      return (
                        <div key={index} className="col-1 p-2 center"
                          style={{
                            margin: "5px",
                            backgroundColor: item.question !== "" ? "#fad4d4" : "#fafad4",
                            fontWeight: "bold",
                            border: "2px solid black",
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setCourseEditData(item)
                            setCourseEditKey(Object.keys(CourseContent)[index])
                            setCourseContentEdit(true)

                          }}
                        >
                          {item.chapter_number}
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>




      <div className="row">
        <div className="col-1"></div>
        <div className="col-10 form-view mb-3">
          <h4><center>Course Other Description</center></h4>
          <table>
            <tbody>
              <tr>
                <td className="col-3">Description</td>
                <td className="col-6">
                  <textarea className="input-common-4" rows={5}
                    value={CourseDescription} placeholder="Course Description"
                    onChange={(event) => { setCourseDescription(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Course Time (in {CourseType == "Online Class" ? "days" : "hours"})</td>
                <td className="col-6">
                  <input className="input-common-4"
                    value={CourseTime} placeholder="Course Time"
                    onChange={(event) => { setCourseTime(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Total Resources</td>
                <td className="col-6">
                  <input className="input-common-4"
                    value={TotalResources} placeholder="Total Resources"
                    onChange={(event) => { setTotalResources(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Course Price</td>
                <td className="col-6">
                  <input className="input-common-4"
                    value={CoursePrice} placeholder="Course Price"
                    onChange={(event) => { setCoursePrice(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Discount</td>
                <td className="col-6">
                  <input className="input-common-4"
                    value={Discount} placeholder="Discount"
                    onChange={(event) => { setDiscount(event.target.value) }}
                  />
                </td>
              </tr>
              {/* <tr>
                <td className="col-3">What Will You Learn</td>
                <td className="col-6">
                  {Object.values(WhatWillYouLearn).map((item, index) => (
                    <div key={index}>
                      {index + 1}. <input className="input-common-5" style={{ marginBottom: 5 }}
                        value={item} placeholder="What will you learn point 1"
                        onChange={(event) => {
                          var WhatWillYouLearnMem = WhatWillYouLearn;
                          WhatWillYouLearnMem = {
                            ...WhatWillYouLearnMem,
                            [`item-${index}`]: event.target.value
                          }
                          setWhatWillYouLearn(WhatWillYouLearnMem)
                        }}
                      />
                    </div>
                  ))}
                  {Object.values(WhatWillYouLearn).length + 1}. <input className="input-common-5"
                    value={WhatWillYouLearnCache} placeholder={`What will you learn point ${Object.values(WhatWillYouLearn).length + 1}`}
                    onChange={(event) => { setWhatWillYouLearnCache(event.target.value) }}
                  />
                  <span style={{ paddingLeft: 10, cursor: "pointer" }}
                    onClick={() => {
                      var WhatWillYouLearnMem = WhatWillYouLearn
                      WhatWillYouLearnMem = {
                        ...WhatWillYouLearnMem,
                        [`item-${Object.values(WhatWillYouLearnMem).length}`]: WhatWillYouLearnCache
                      }
                      setWhatWillYouLearn(WhatWillYouLearnMem)
                      setWhatWillYouLearnCache("")
                    }}
                  >Add</span>
                </td>
              </tr> */}
              {/* <tr>
                <td className="col-3">Requirements</td>
                <td className="col-6">
                  {Object.values(Requirements).map((item, index) => (
                    <div key={index}>
                      {index + 1}. <input className="input-common-5" style={{ marginBottom: 5 }}
                        value={item} placeholder="Requirements Point 1"
                        onChange={(event) => {
                          var RequirementsMem = Requirements;
                          RequirementsMem = {
                            ...RequirementsMem,
                            [`item-${index}`]: event.target.value
                          }
                          setRequirements(RequirementsMem)
                        }}
                      />
                    </div>
                  ))}
                  {Object.values(Requirements).length + 1}. <input className="input-common-5"
                    value={RequirementsCache} placeholder={`Requirements Point ${Object.values(Requirements).length + 1}`}
                    onChange={(event) => { setRequirementsCache(event.target.value) }}
                  />
                  <span style={{ paddingLeft: 10, cursor: "pointer" }}
                    onClick={() => {
                      var RequirementsMem = Requirements
                      RequirementsMem = {
                        ...RequirementsMem,
                        [`item-${Object.values(RequirementsMem).length}`]: RequirementsCache
                      }
                      setRequirements(RequirementsMem)
                      setRequirementsCache("")
                    }}
                  >Add</span>
                </td>
              </tr> */}
              {/* <tr>
                <td className="col-3">Who is this course for</td>
                <td className="col-6">
                  {Object.values(WhoisThisCourseFor).map((item, index) => (
                    <div key={index}>
                      {index + 1}. <input className="input-common-5" style={{ marginBottom: 5 }}
                        value={item} placeholder="Who is this course for Point 1"
                        onChange={(event) => {
                          var WhoisThisCourseForMem = WhoisThisCourseFor;
                          WhoisThisCourseForMem = {
                            ...WhoisThisCourseForMem,
                            [`item-${index}`]: event.target.value
                          }
                          setWhoisThisCourseFor(WhoisThisCourseForMem)
                        }}
                      />
                    </div>
                  ))}
                  {Object.values(WhoisThisCourseFor).length + 1}. <input className="input-common-5"
                    value={WhoisThisCourseForCache} placeholder={`Who is this course for Point ${Object.values(WhoisThisCourseFor).length + 1}`}
                    onChange={(event) => { setWhoisThisCourseForCache(event.target.value) }}
                  />
                  <span style={{ paddingLeft: 10, cursor: "pointer" }}
                    onClick={() => {
                      var WhoisThisCourseForMem = WhoisThisCourseFor
                      WhoisThisCourseForMem = {
                        ...WhoisThisCourseForMem,
                        [`item-${Object.values(WhoisThisCourseForMem).length}`]: WhoisThisCourseForCache
                      }
                      setWhoisThisCourseFor(WhoisThisCourseForMem)
                      setWhoisThisCourseForCache("")
                    }}
                  >Add</span>
                </td>
              </tr> */}
            </tbody>
          </table>
        </div>
      </div>

      {
        CourseContentEdit &&
        <section className="modal" >
          <div className="row">
            <div className="col-md-2 col-1"></div>
            <div className="col-md-8 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'scroll', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setCourseContentEdit(false)
                    setCourseEditData([])
                    setCourseEditKey("")
                  }}
                >X</div>

                <CourseUploadComp
                  oneChapterData={CourseEditData} setCourseEditData={setCourseEditData}
                  keyValue={CourseEditKey} setCourseEditKey={setCourseEditKey}
                  CourseContent={CourseContent} setCourseContent={setCourseContent}
                  ContentPreview={ContentPreview} setContentPreview={setContentPreview}
                  setCourseContentEdit={setCourseContentEdit}
                  CourseType={CourseType}
                />
              </div>
            </div>
          </div>
        </section>
      }

      {
        reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }
    </div >
  )

}



const CourseUploadComp = ({
  oneChapterData, setCourseEditData,
  keyValue, setCourseEditKey, setCourseContentEdit,
  CourseContent, setCourseContent,
  ContentPreview, setContentPreview,
  CourseType
}) => {
  const [ChapterNumber, setChapterNumber] = React.useState(oneChapterData.chapter_number)
  const [Title, setTitle] = React.useState(oneChapterData.title)
  const [Description, setDescrition] = React.useState(oneChapterData.description)
  const [Time, setTime] = React.useState(oneChapterData.time)
  const [IsPreview, setIsPreview] = React.useState(oneChapterData.is_preview)
  const [VideoLink, setVideoLink] = React.useState(oneChapterData.video_link)
  const [YoutubeID, setYoutubeID] = React.useState(oneChapterData.youtube_id)
  const [ChapterType, setChapterType] = React.useState(oneChapterData.chapter_type)
  const [Content, setContent] = React.useState(oneChapterData.content)
  const [PDFURL, setPDFURL] = React.useState(oneChapterData.pdf_url)
  const [PdfList, setPdfList] = React.useState(JSON.parse(oneChapterData.pdf_list))
  const [AudioList, setAudioList] = React.useState(JSON.parse(oneChapterData.audio_list))
  const [AudioURL, setAudioURL] = React.useState("")
  const [PageNumber, setPageNumber] = React.useState("")
  const [TitleAudio, setTitleAudio] = React.useState("")

  function YouTubeGetID(url) {
    url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if (url[2] !== undefined)
      setYoutubeID(url[2].split(/[^0-9a-z_\-]/i)[0])
    // console.log(url[2].split(/[^0-9a-z_\-]/i)[0])
    return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
  }
  return (
    <div>
      <div style={{ maxHeight: "60vh", overflowY: "scroll" }}>
        <table>
          <tbody>
            <tr>
              <td className="col-3">Chapter Number</td>
              <td className="col-6">
                {ChapterNumber}
                {/* <input className="input-common-4"
                value={CourseCategory} placeholder="Course Category"
                onChange={(event) => { setCourseCategory(event.target.value) }}
              /> */}
              </td>
            </tr>
            <tr>
              <td className="col-3">Chapter Title</td>
              <td className="col-6">
                <input className="input-common-4"
                  value={Title} placeholder="Chapter Title"
                  onChange={(event) => { setTitle(event.target.value) }}
                />
              </td>
            </tr>
            <tr>
              <td className="col-3">Chapter Description</td>
              <td className="col-6">
                <input className="input-common-4"
                  value={Description} placeholder="Chapter Description"
                  onChange={(event) => { setDescrition(event.target.value) }}
                />
              </td>
            </tr>
            <tr>
              <td className="col-3">Chapter Time</td>
              <td className="col-6">
                <input className="input-common-4"
                  value={Time} placeholder="Chapter Time"
                  onChange={(event) => { setTime(event.target.value) }}
                />
              </td>
            </tr>
            <tr>
              <td className="col-3">Free/Pro</td>
              <td className="col-6">
                <CustomButton setData={setIsPreview} Data={IsPreview} DataValue={"Free"} />
                <CustomButton setData={setIsPreview} Data={IsPreview} DataValue={"Pro"} />
              </td>
            </tr>
            <tr>
              <td className="col-3">Chapter Type</td>
              <td className="col-6">
                <CustomButton setData={setChapterType} Data={ChapterType} DataValue={"Video"} />
                <CustomButton setData={setChapterType} Data={ChapterType} DataValue={"Text"} />
                <CustomButton setData={setChapterType} Data={ChapterType} DataValue={"PDF"} />
              </td>
            </tr>
            {ChapterType == "Video" &&
              <>
                <tr>
                  <td className="col-3">Video Link</td>
                  <td className="col-6">
                    <input className="input-common-4"
                      value={VideoLink} placeholder="Video Link"
                      onChange={(event) => {
                        setVideoLink(event.target.value)
                        YouTubeGetID(event.target.value)
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="col-3">Youtube ID</td>
                  <td className="col-6">
                    <input className="input-common-4"
                      value={YoutubeID} placeholder="Youtube ID"
                      onChange={(event) => { setYoutubeID(event.target.value) }}
                    />
                  </td>
                </tr>
              </>
            }
            {ChapterType == "Text" &&
              <tr>
                <td className="col-3">Content</td>
                <td className="col-6">
                  <textarea className="input-common-4" rows={5}
                    value={Content} placeholder="Content"
                    onChange={(event) => { setContent(event.target.value) }}
                  />
                </td>
              </tr>
            }
            {ChapterType == "PDF" ?
              <tr>
                <td className="col-3">PDF File</td>
                <td className="col-6">
                  <FileUpload
                    ImageUrl={PDFURL}
                    setImageUrl={setPDFURL}
                  />
                </td>
              </tr>
              :
              <>
                <tr>
                  <td className="col-3">PDF File</td>
                  <td className="col-6">
                    {Object.values(PdfList).map((item, index) => (
                      <div key={index}>
                        <div style={{ display: "inline" }}>
                          <div style={{ display: "inline-block" }}>
                            {index + 1}.
                          </div>
                          <div style={{ display: "inline-block" }}>
                            <FileUploadChapters
                              PDfGroup={PdfList}
                              setPDFGroup={setPdfList}
                              ThisPDF={item}
                              index={index}
                              type={"pdf"}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                    <div style={{ display: "inline" }}>
                      <div style={{ display: "inline-block" }}>
                        {Object.values(PdfList).length + 1}.
                      </div>
                      <div style={{ display: "inline-block" }}>
                        <FileUploadChapters
                          PDfGroup={PdfList}
                          setPDFGroup={setPdfList}
                          ThisPDF={""}
                          index={Object.values(PdfList).length}
                          type={"pdf"}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              </>
            }
            <tr>
              <td className="col-3">Audio Files</td>
              <td className="col-6">

                <table>
                  <tbody>
                    {Object.values(AudioList).map((item, index) => (
                      <tr key={index} style={{ cursor: "pointer", padding: "5px 0" }}>
                        <td>
                          {index + 1}
                        </td>
                        <td className="col-6">
                          <AudioUpload2
                            ImageUrl={AudioURL}
                            setImageUrl={setAudioURL}
                            PDfGroup={AudioList}
                            setPDFGroup={setAudioList}
                            item={item}
                            index={index}
                            newUpload={false}
                          />
                        </td>
                        <td>
                          <div style={{ width: "100%" }}>
                            <input className="input-common-half" style={{ width: "100%", marginTop: 5 }}
                              value={item.title} placeholder="Pg Start"
                              onChange={(event) => {
                                var pdf = AudioList;
                                pdf = {
                                  ...pdf,
                                  [`item-${index}`]: {
                                    "title": `${event.target.value}`,
                                    "page_number": `${item.page_number}`,
                                    "audio_url": `${item.audio_url}`,
                                  }
                                }
                                setAudioList(pdf)
                              }}
                            />
                          </div>
                        </td>
                        <td>
                          <div style={{ width: "100%" }}>
                            <input className="input-common-half" style={{ width: "100%", marginTop: 5 }}
                              value={item.page_number} placeholder="Pg End"
                              onChange={(event) => {
                                var pdf = AudioList;
                                pdf = {
                                  ...pdf,
                                  [`item-${index}`]: {
                                    "title": `${item.title}`,
                                    "page_number": `${event.target.value}`,
                                    "audio_url": `${item.audio_url}`,
                                  }
                                }
                                setAudioList(pdf)
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr style={{ cursor: "pointer", padding: "5px 0" }}>
                      <td>
                        {Object.values(AudioList).length + 1}
                      </td>
                      {/* {AudioURL} */}
                      <td className="col-3">
                        <AudioUpload2
                          ImageUrl={AudioURL}
                          setImageUrl={setAudioURL}
                          PDfGroup={AudioList}
                          setPDFGroup={setAudioList}
                          item={{
                            "title": `${Title}`,
                            "page_number": `${PageNumber}`,
                            "audio_url": `${AudioURL}`,
                          }}
                          index={Object.keys(AudioList).length}
                          newUpload={true}
                        />
                      </td>
                      <td className="col-3">
                        <div style={{ width: "100%" }}>
                          <input className="input-common-half" style={{ width: "100%", marginTop: 5 }}
                            value={TitleAudio} placeholder="Page Start"
                            onChange={(event) => {
                              setTitleAudio(event.target.value)
                            }}
                          />
                        </div>
                      </td>
                      <td className="col-3">
                        <div style={{ width: "100%" }}>
                          <input className="input-common-half" style={{ width: "100%", marginTop: 5 }}
                            value={PageNumber} placeholder="Page Tp"
                            onChange={(event) => {
                              setPageNumber(event.target.value)
                            }}
                          />
                        </div>
                      </td>
                      <td onClick={() => {
                        // setNumberofChapters(event.target.value)
                        var pdf = AudioList;
                        pdf = {
                          ...pdf,
                          [`item-${Object.keys(AudioList).length}`]: {
                            "title": `${TitleAudio}`,
                            "page_number": `${PageNumber}`,
                            "audio_url": `${AudioURL}`,
                          }
                        }
                        setAudioList(pdf)
                        setTitle("")
                        setPageNumber("")
                        setAudioURL("")
                        console.log(pdf)
                      }}>
                        Add
                      </td>
                    </tr>

                  </tbody>
                </table>

                {/* {Object.values(AudioList).map((item, index) => (
                  <div key={index}>
                    <div style={{ display: "inline" }}>
                      <div style={{ display: "inline-block" }}>
                        {index + 1}.
                      </div>
                      <div style={{ display: "inline-block" }}>
                        <FileUploadChapters
                          PDfGroup={AudioList}
                          setPDFGroup={setAudioList}
                          ThisPDF={item}
                          index={index}
                          type={"audio"}
                        />
                      </div>
                    </div>
                  </div>
                ))}
                <div style={{ display: "inline" }}>
                  <div style={{ display: "inline-block" }}>
                    {Object.values(AudioList).length + 1}.
                  </div>
                  <div style={{ display: "inline-block" }}>
                    <FileUploadChapters
                      PDfGroup={AudioList}
                      setPDFGroup={setAudioList}
                      ThisPDF={""}
                      index={Object.values(AudioList).length}
                      type={"audio"}
                    />
                  </div>
                </div> */}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <center>
        <div style={{ width: "30%" }} className="sign-in-button-1"
          onClick={() => {
            setCourseContent({
              ...CourseContent,
              [keyValue]: {
                "chapter_number": `${ChapterNumber}`,
                "title": `${Title}`,
                "time": `${Time}`,
                "description": `${Description}`,
                "is_preview": `${IsPreview}`,
                "chapter_type": `${ChapterType}`,
                "video_link": `${VideoLink}`,
                "youtube_id": `${YoutubeID}`,
                "content": `${Content}`,
                "pdf_url": `${PDFURL}`,
                "pdf_list": `${JSON.stringify(PdfList)}`,
                "audio_list": `${JSON.stringify(AudioList)}`,
              }
            })
            setContentPreview({
              ...ContentPreview,
              [keyValue]: {
                "chapter_number": `${ChapterNumber}`,
                "title": `${Title}`,
                "time": `${Time}`,
                "description": `${Description}`,
                "is_preview": `${IsPreview}`,
                "chapter_type": `${ChapterType}`,
                "video_link": IsPreview == "Free" ? `${VideoLink}` : "",
                "youtube_id": IsPreview == "Free" ? `${YoutubeID}` : "",
                "content": IsPreview == "Free" ? `${Content}` : "",
                "pdf_url": IsPreview == "Free" ? `${PDFURL}` : "",
                "pdf_list": IsPreview == "Free" ? `${JSON.stringify(PdfList)}` : "[]",
                "audio_list": IsPreview == "Free" ? `${JSON.stringify(AudioList)}` : "[]",
              }
            })
            setCourseEditKey(``)
            setCourseContentEdit(false)
          }}
        >Done</div>
      </center>
    </div >
  )
}

